import { render, staticRenderFns } from "./ItemExecucao.vue?vue&type=template&id=1544e212&scoped=true&"
import script from "./ItemExecucao.vue?vue&type=script&lang=js&"
export * from "./ItemExecucao.vue?vue&type=script&lang=js&"
import style0 from "./ItemExecucao.vue?vue&type=style&index=0&id=1544e212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1544e212",
  null
  
)

export default component.exports